module.exports = ngModule => {
  require('./formlyUtil')(ngModule);
  require('./formlyWarn')(ngModule);
};



/** WEBPACK FOOTER **
 ** ../~/jshint-loader!./services/index.js
 **/